import styled from "styled-components";
import { useChat } from "../context/ChatContext";
import IconButton from "./IconButton";
import { HiOutlinePaperAirplane } from "react-icons/hi2";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 1rem;

  padding: 0 1rem;

  /* & > button {
    position: absolute;
    right: 4%;
    top: 62%;
    transform: translateY(-100%);
    padding: 0 !important;

    @media only screen and (max-width: 640px) {
      right: 8%;
    }

    @media only screen and (max-width: 346px) {
      top: 56%;
    }
  } */
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: var(--color-primary);
  border-radius: 1rem;
  padding: 0.4rem;
`;

const Input = styled.input`
  border: none;
  background: transparent;
  flex: 1;

  color: #fff;
  padding-left: 0.6rem;
  

  &::placeholder {
    color: var(--input-placeholder-color);
  }

  &:focus {
    outline: none;
  }
`;

const InputActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const InputActionButton = styled.button`
  background: none;
  border: none;
  color: var(--chat-color);
  border-radius: 1rem;
  padding: 0 0.5rem;

  &:hover {
    background-color: red;
    color: white;
  }
`;

const Disclaimer = styled.span`
  text-align: center;
  font-size: 0.75rem;

  color: var(--chat-color);
`;

/**
 * This component renders an input field for user input along two action buttons
 * - Clear chat: Clears the chat input
 * - Cancel question: Cancels the ongoing questions
 *
 * @returns {JSX.Element} A JSX.Element that renders the Input field.
 */
function DialogInput() {
  const {
    question,
    setQuestion,
    handleKeyDown,
    ask,
    cancelAnswer,
    loadingAnswer,
    setConversation,
    conversation,
  } = useChat();

  function handleClear() {
    cancelAnswer();
    setConversation([]);

    localStorage.removeItem("chat-dialog");
  }

  function handleCancelQuestion() {
    conversation.pop();

    cancelAnswer();

    setConversation(conversation);
    localStorage.setItem(
      "chat-dialog",
      JSON.stringify(
        conversation.map((message) => ({ ...message, read: true }))
      )
    );
  }

  return (
    <Container>
      <InputActions>
        {!!conversation.length && (
          <InputActionButton onClick={handleClear}>
            Clear chat
          </InputActionButton>
        )}
        {loadingAnswer && (
          <InputActionButton onClick={handleCancelQuestion}>
            Cancel question
          </InputActionButton>
        )}
      </InputActions>

      <InputContainer>
        <Input
          placeholder="Ask Atcheza"
          onChange={(e) => setQuestion(e.target.value)}
          value={question}
          autoFocus
          type="text"
          onKeyDown={handleKeyDown}
        />

        <IconButton disabled={!question} onClick={ask}>
          <HiOutlinePaperAirplane />
        </IconButton>
      </InputContainer>

      {/* DIVULGAÇÃO DO ART. 50 (Regulamento (UE) 2024/1689) NA WEB.
          Esta linha é a divulgação, não um enfeite. Desde 08/09/2026 o rodapé
          por mensagem não é mais renderizado nas respostas (ver o comentário em
          Answer.jsx): aqui é onde a obrigação é cumprida na web.

          Fica FORA de qualquer condicional de propósito, e `DialogWindow` é que
          rola (`flex: 1; overflow-y: auto`), então este aviso permanece em tela
          durante toda a conversa — inclusive ANTES da primeira pergunta, que é
          o que o Art. 50 pede ("no mais tardar no momento da primeira
          interação"). Não envolver em condicional, não mover pra dentro da área
          que rola.

          ESTÁ EM INGLÊS porque a superfície web é em inglês inteira (Ask
          Atcheza, Clear chat, Sources). Se a interface algum dia for traduzida
          pra português, ESTE AVISO TEM QUE SER TRADUZIDO NO MESMO MOVIMENTO:
          divulgação que a pessoa não lê não informa ninguém, e aí a
          conformidade cai junto. Não é string de UI como as outras.

          No WhatsApp o rodapé por mensagem continua, porque lá não existe aviso
          fixo. A redação é coberta por DialogInput.test.jsx. */}
      <Disclaimer>
        Atcheza is AI and can make mistakes. Verify regulations and dates with local authorities.
      </Disclaimer>
    </Container>
  );
}

export default DialogInput;
